import { GetReportsListQuery } from '@/api';

type Report = NonNullable<NonNullable<GetReportsListQuery['getReportsConfigurations']>['reportsConfigurations']>[number];

export const getReportLink = (item: Report) =>
  `/report/${encodeURIComponent(item.menuTitle)}`;
